import { textAlign as align } from './text.css';

type TextAlign = Parameters<typeof align>[0];

export type TextProps = {
  textAlign?: TextAlign['textAlign'];
};

const textInterpolations = {
  textAlign: ({ textAlign }: Pick<TextProps, 'textAlign'>) =>
    textAlign === undefined ? {} : { class: align({ textAlign }) }
};

export { textInterpolations };
